<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { __ } from '@oat-sa-private/ui-core';
    import { testSessionStatus } from '../../../session/sessionStates.js';
    import { getTestStateStore, getTestSessionStatusStore } from '../../../testsStateStore.js';

    /**
     * @typedef {Object} Props
     * @property {String} serviceCallId - id of test session
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        serviceCallId
    } = $props();

    // svelte-ignore state_referenced_locally
    const testStateStore = getTestStateStore(serviceCallId);
    // svelte-ignore state_referenced_locally
    const statusStore = getTestSessionStatusStore(serviceCallId);

    /**
     * Build the hidden heading from the current state
     * @returns {Object|void} the item headings
     */
    function getHeadings() {
        const testMap = testStateStore.getTestMap();
        if (testMap) {
            const testPart = testStateStore.getCurrentTestPart();
            const section = testStateStore.getCurrentSection();
            const item = testStateStore.getCurrentItem();
            if (testPart && section && item) {
                const sections = Object.values(testPart.sections);
                const position = item.position + 1;
                const total = testPart.stats.total;
                const positionInSection = sections.indexOf(section) + 1;
                const totalSections = sections.length;

                return {
                    current: __('Current question %d of %d', position, total),
                    located: __('Located in question group %d of %d.', positionInSection, totalSections),
                    state: item.answered ? __('answered') : __('unanswered')
                };
            }
        }
    }

    let itemHeadings = $derived($testStateStore ? getHeadings() : {});
</script>

{#if itemHeadings && $statusStore === testSessionStatus.interacting}
    <span>{itemHeadings.current} - {itemHeadings.state}. {itemHeadings.located}</span>
{/if}
